import React, {Component} from 'react'

export default class Val1 extends Component {
  render() {
    return (
      <div className="pt-20">
        <div className=" " style={{backgroundColor: '#F3F8F9', border: '1px #F3F8F9 solid', height: '0px', marginBottom: '-3.5rem'}} />
        <div className=" grid-xl py-12 th-home--val">
          <div className="container grid-xl text-center">
            <p className="h3 th-home--mobilefonth3 text-white" style={{color: '#00414b', marginBottom: '.2rem'}}>
              A complete tool kit for on-the-go real estate professionals.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
